import React from "react";
import Dropdown from "components/dropdown";
import { BsThreeDots } from "react-icons/bs";
import { Button } from "@mui/material";
import { FaTshirt } from "react-icons/fa";

function TelaMenu(props) {
  const { transparent, setOpen : setOpenModal , setMode} = props;
  const [open, setOpen] = React.useState(false);
  return (
    <Dropdown
      button={
        <button
          onClick={() => setOpen(!open)}
          open={open}
          className={`flex items-center text-xl hover:cursor-pointer ${
            transparent
              ? "bg-none text-white hover:bg-none active:bg-none"
              : "bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10"
          } linear justify-center rounded-lg font-bold transition duration-200`}
        >
          <BsThreeDots className="h-6 w-6" />
        </button>
      }
      animation={"origin-top-right transition-all duration-300 ease-in-out"}
      classNames={`${transparent ? "top-8" : "top-11"} right-0 w-max`}
      children={
        <div className="z-50 w-max rounded-xl bg-white py-3 px-4 text-sm shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          
          <Button
          onClick={()=> {;setMode("POST");setOpenModal(true)}}
          >
          <p className="hover:text-black flex cursor-pointer items-center gap-2  text-brand-500 hover:font-medium">
            <span>
              <FaTshirt />
            </span>
            Agregar Nueva Tela
          </p>
          </Button>

        </div>
      }
    />
  );
}

export default TelaMenu;
